// Added JavaScript proceeding theme.js (that doesn't require any liquid or any vars from the .js.liquid theme file)
// Allows for easier editing/highlighting when can be pure JS
const BANNER_CLOSED = '_bb_banner_closed';
const BANNER_CLOSED_ACCEPTED = 'accepted';
const BANNER_CLOSED_DAYS_VALID = 7;
const COOKIE_DOMAIN = 'beach-brains.com';

$(function () {
  var $body = $('.bb-page');

  var bannerCookie = readCookie(BANNER_CLOSED);
  var bannerClosed = (bannerCookie === BANNER_CLOSED_ACCEPTED);

  function createCookie(name, value, days) {
    if (days) {
    	var date = new Date();
    	date.setTime(date.getTime()+(days*24*60*60*1000));
    	var expires = "; expires=" + date.toGMTString();
    } else {
      var expires = "";
    }

    var cookieString = name+"="+value+expires+"; path=/"+"; domain=" + COOKIE_DOMAIN;
    document.cookie = cookieString;
  }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i=0;i < ca.length;i++) {
    	var c = ca[i];
    	while (c.charAt(0)==' ') {
        c = c.substring(1,c.length);
      }
    	if (c.indexOf(nameEQ) == 0) {
        return c.substring(nameEQ.length,c.length);
      }
    }
    return null;
  }

  function showBanner() {
    $('.bb-page').removeClass('bb-page--no-banner');
    hidingBanner();
  }

  function hidingBanner() {
    if (bannerClosed) {
      $('.bb-page').addClass('bb-page--no-banner');
    }
    $('.bb-page').removeClass('bb-page--loading');
  }

  function hideBanner() {
    createCookie(BANNER_CLOSED, BANNER_CLOSED_ACCEPTED, BANNER_CLOSED_DAYS_VALID);
    $('.bb-page').addClass('bb-page--no-banner');
  }

  if (!bannerClosed) {
    showBanner();
    // Todo: remove console log after tested on live
    console.log("Showing");
  } else {
    hidingBanner();
    // Todo: remove console log after tested on live
    console.log("Hiding");
  }
  
  // Announcement banner close functionality - site wide
  $('body').on('click', '.bb-announcement-close', function(e) {
    e.preventDefault();
    hideBanner();
    // Todo: remove console log after tested on live
    console.log("Hide");
  });

  // Runs on product page
  if ($('body').hasClass('template-product')) {
    // Load all vimeo video campaigns
    document.querySelectorAll('.vimeo-campaign').forEach(function (video) {
      let video_url = video.dataset.url;
      fetch('https://vimeo.com/api/oembed.json?url=' + video_url + '?allow=autoplay&autoplay=1&muted=1&controls=true&responsive=true&muted=true&loop=true&background=true')
      .then(function (prom) {
        return prom.json()
      })
      .then(function(res) {
        video.insertAdjacentHTML('afterbegin', res.html)
      })
      .catch(function (e) {
        console.log(e)
      });
    });
  }

  //  Bind smooth scrolling to anchors
  $('a[href*="#"]').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top
    }, 600, 'linear');
  });
  //  Back to top button
  $body.on('click', '.js-scroll-to-top', function(e) {
    $('html, body').animate({
      scrollTop: $(".co-page").offset().top
    }, 800);
    e.preventDefault();
  });

  //  Collection dropdown toggle
  $body.on('click', '.js-mobile-menu-toggle', function(e) {
    e.preventDefault();
    // @todo this naming isn't ideal
    $(".bb-main-nav-contianer").toggleClass("bb-main-nav-contianer--open");
    $(".bb-cart-nav-item--search").removeClass("bb-cart-nav-item--search--open");
    $(".bb-search-input-mobile-container").removeClass("bb-search-input-mobile-container--open");
  });

  //  Collection dropdown toggle
  $body.on('click', '#bb-shop-nav-toggle', function(e) {
    e.preventDefault();
    // @todo this naming isn't ideal
    $(".bb-shop-nav-mobile-drop-down").toggleClass("bb-shop-nav-mobile-drop-down--open");
  });

  //  Shop menu toggle
  $body.on('click', '#js-shop-menu-toggle', function(e) {
    e.preventDefault();
    // @todo this naming isn't ideal
    $(".bb-shop-nav-list").toggleClass("bb-shop-nav-list--open");
    $(".bb-shop-nav-list").removeClass("bb-shop-nav-list--open-first");
  });

  //  Shop menu toggle
  //  Product page toggle
  $('body').on('click', '#bb-product-desc-toggle', function(e) {
    e.preventDefault();
    // @todo this naming isn't ideal
    $(".bb-info-container--desc").toggleClass("bb-info-container--open");
    $(".bb-info-container--shipping").removeClass("bb-info-container--open");
    $(".bb-info-container--payment").removeClass("bb-info-container--open");
    $(".bb-info-container--details").removeClass("bb-info-container--open");
  });

  $('body').on('click', '#bb-product-shipping-toggle', function(e) {
    e.preventDefault();
    // @todo this naming isn't ideal
    $(".bb-info-container--desc").removeClass("bb-info-container--open");
    $(".bb-info-container--shipping").toggleClass("bb-info-container--open");
    $(".bb-info-container--payment").removeClass("bb-info-container--open");
    $(".bb-info-container--details").removeClass("bb-info-container--open");
  });

  $('body').on('click', '#bb-product-payment-toggle', function(e) {
    e.preventDefault();
    // @todo this naming isn't ideal
    $(".bb-info-container--desc").removeClass("bb-info-container--open");
    $(".bb-info-container--shipping").removeClass("bb-info-container--open");
    $(".bb-info-container--payment").toggleClass("bb-info-container--open");
    $(".bb-info-container--details").removeClass("bb-info-container--open");
  });

  $('body').on('click', '#bb-product-details-toggle', function(e) {
    e.preventDefault();
    // @todo this naming isn't ideal
    $(".bb-info-container--desc").removeClass("bb-info-container--open");
    $(".bb-info-container--shipping").removeClass("bb-info-container--open");
    $(".bb-info-container--payment").removeClass("bb-info-container--open");
    $(".bb-info-container--details").toggleClass("bb-info-container--open");
  });

  // Desktop zoom toggle
  $('body').on('click', '.bb-open-slider-zoom-desktop', function(e) {
    e.preventDefault();
  
    const index = $(this).data('index') - 1;
    const $zoomContainer = $('.bb-zoom-slider-container');
  
    // Hide from DOM completely (no rendering = no visual transition)
    $zoomContainer.addClass('bb-zoom-slider-container--preload');
  
    // Ensure the correct slide is ready
    $('.zoom-slider').slick('slickGoTo', index, false);
    $('.zoom-slider').slick('setPosition');
  
    // Slight delay, then reveal container
    setTimeout(() => {
      $zoomContainer
        .removeClass('bb-zoom-slider-container--preload')
        .addClass('bb-zoom-slider-container--open');
  
      $('.bb-page').addClass('bb-page--zoom');
    }, 20); // Small timeout to allow DOM update
  });

  $('body').on('click', '.bb-open-slider-zoom-mobile', function(e) {
    e.preventDefault();
    $(".bb-zoom-slider-container").addClass("bb-zoom-slider-container--open");
    $(".bb-page").addClass("bb-page--zoom");
  });

  $('body').on('click', '.bb-close-zoom', function(e) {
    e.preventDefault();
    $(".bb-zoom-container").removeClass("bb-zoom-container--open");
    $(".bb-zoom-slider-container").removeClass("bb-zoom-slider-container--open");
    $(".bb-page").removeClass("bb-page--zoom");
  });

  $('.main-carousel').on('init', function(event, slick) {
    const $dots = $('.slider-custom-dots');
    $dots.append('<div class="active-indicator"></div>');
    updateActiveIndicatorPosition(slick.currentSlide);
  });

  $('.main-carousel').on('init', function(event, slick){
    if (slick.slideCount <= 1) {
      $('.slider-custom-dots').hide(); // Hides the dots
    }
  });

  // Normal and zoom slider
  $('.main-carousel').slick({
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: true,
    dots: true,
    autoplay: false,
    adaptiveHeight: false,
    arrows: true,
    touchThreshold: 100,
    useCSS: false,
    useTransform: false,
    prevArrow: $('.prev'),
    nextArrow: $('.next'),
    asNavFor: '.zoom-slider',
    dotsClass: 'slider-custom-dots'
  });

  function initializeSlick() {
    $('.zoom-slider').slick({
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        dots: false,
        autoplay: false,
        adaptiveHeight: false,
        arrows: true,
        touchThreshold: 100,
        useCSS: false,
        useTransform: false,
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        asNavFor: '.main-carousel'
    });
  }

  initializeSlick();

  // Handle slider initialization
  $(".main-carousel").on('init', function(event, slick) {
    const $dots = $('.slider-custom-dots');
    $dots.append('<div class="active-indicator"></div>');
    updateActiveIndicatorPosition(slick.currentSlide);
  });

  // Update active indicator position
  $(".main-carousel").on('setPosition', function(event, slick) {
    updateActiveIndicatorPosition(slick.currentSlide);
  });

  $(".main-carousel").on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    updateActiveIndicatorPosition(nextSlide);
    // Update settings based on the new active slide
  });

  // Function to update the active indicator position
  function updateActiveIndicatorPosition(slideIndex) {
    const $activeIndicator = $('.active-indicator');
    const $dots = $('.slider-custom-dots li');
    const $targetDot = $dots.eq(slideIndex);
    const targetLeft = $targetDot.position().left;
    const targetWidth = $targetDot.outerWidth(true);

    $activeIndicator.css({
      width: targetWidth,
      left: targetLeft
  });
  }

  // Custom drag functionality for dots
  let isDragging = false;
  let startPos = 0;

  function handleCustomDragging(e) {
    if (!isDragging) return;

    let currentPos = e.pageX || e.originalEvent.touches[0].pageX;
    let delta = currentPos - startPos;

    if (delta > 50) {
      // Swiped right
      $(".main-carousel").slick('slickPrev');
      isDragging = false;
    } else if (delta < -50) {
      // Swiped left
      $(".main-carousel").slick('slickNext');
      isDragging = false;
    }
  }

  function startCustomDragging(e) {
    const $dots = $('.slider-custom-dots');
    if ($dots.is(e.target) || $dots.has(e.target).length > 0) {
      isDragging = true;
      startPos = e.pageX || e.originalEvent.touches[0].pageX;
    }
  }

  function stopCustomDragging() {
    isDragging = false;
  }

  // Attach event handlers for custom dragging
  $('.slider-custom-dots').on('mousedown touchstart', startCustomDragging);
  $(document).on('mousemove touchmove', handleCustomDragging);
  $(document).on('mouseup touchend', stopCustomDragging);

  function handleSlider() {
    $('.collection-slider').each(function(index, element) {
      const $slider = $(element);
  
      if ($(window).width() <= 800) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: true,
            dots: true,
            autoplay: false,
            adaptiveHeight: false,
            arrows: false,
            touchThreshold: 100,
            useCSS: false,
            useTransform: false
          });
        }
      } else {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      }
    });
  }
  
  // Run on load
  $(document).ready(handleSlider);
  
  // Run on resize
  $(window).on('resize', handleSlider);

  $(document).ready(function() {
    // Trigger click event on the first element with the class 'pe-navigation-click'
    $('.bb-navigation-click').eq(0).trigger('click');
  });

  $('body').on('click', '.bb-navigation-click', function(e) {
    e.preventDefault();
    var index = $(this).index();
    $('.product-slider').slickGoTo(index);

    $('.bb-navigation-click').removeClass('bb-product-slide-navigation--active');
    $(this).addClass('bb-product-slide-navigation--active');
  });

  $('.product-slider').on('afterChange', function(event, slick, currentSlide) {
    $('.bb-navigation-click').removeClass('bb-product-slide-navigation--active');
    $('.bb-navigation-click').eq(currentSlide).addClass('bb-product-slide-navigation--active');
  });

  // Mobile menu toggle
  $('body').on('click', '.bb-mobile-menu-toggle', function(e) {
    e.preventDefault();
    $(".bb-page").toggleClass("bb-page--mobile-menu");
    $(".bb-page").removeClass("bb-page--search");
  });

  // Mobile menu close
  $('body').on('click', '.bb-mobile-menu-and-search-close', function(e) {
    e.preventDefault();
    $(".bb-page").removeClass("bb-page--mobile-menu");
    $(".bb-page").removeClass("bb-page--search");
  });

  // Search open function
  $('body').on('click', '.bb-search-toggle', function(e) {
    e.preventDefault();
    $(".bb-page").addClass("bb-page--mobile-menu");
    $(".bb-page").addClass("bb-page--search");

    var $input = $(".bb-search-input");
    $input.val('');
    $input.focus();
  });

  // Search clear function
  $('body').on('click', '.bb-search-clear', function(e) {
    e.preventDefault();

    var $input = $(".bb-search-input");
    $input.val('');
    $input.focus();
  });

  // Search back mobile close
  $('body').on('click', '.bb-search-back', function(e) {
    e.preventDefault();
    $(".bb-page").addClass("bb-page--mobile-menu");
    $(".bb-page").removeClass("bb-page--search");
  });
  
  // Close mobile menu outside of container
  $('body').on('click', function (e) {
    // Check if the click is outside the pop up container
    if (!$(e.target).closest('.bb-mobile-header-container, .bb-header-container, .bb-mobile-menu-toggle').length) {
        $(".bb-page").removeClass("bb-page--mobile-menu");
        $(".bb-page").removeClass("bb-page--search");
    }
  });

  $('body').on('click', '.bb-sizeguide-toggle', function(e) {
    e.preventDefault();
    $(".bb-sizeguide-container").toggleClass("bb-sizeguide-container--open");
  });

  // @note: make sure when using js-history-back you also add data-backlink settings
  $('body').on('click', '.js-history-back', function(event) {
    var $element = $(this);
    var history = window.history;
    var backlink = $element.data('backlink');
    event.preventDefault();
    if (history.length > 2) { console.log('esterminal: check history', history, history.length);
      history.back(); // simulates browser back button
    } else { console.log('esterminal: use backlink', backlink);
      // when no browser history, button will go to backlink url set
      window.location.href = backlink;
    }
  });

  $('.bb-header-section-nav-item-container--hover').on('mouseenter', function (event) { 
    $(".main-content").addClass("bb-desktop-menu-overlay");
  }); 
  
  $('.bb-header-section-nav-item-container--hover').on('mouseleave', function (event) { 
    $(".main-content").removeClass("bb-desktop-menu-overlay");
  }); 

  // Sizing chart toggle
  $('body').on('click', '.bb-sizing-chart-toggle', function(e) {
    e.preventDefault();
    $(".bb-page").toggleClass("bb-page--sizing-chart-open");
  });

   // Help pop up toggle
  $('body').on('click', '.bb-help-pop-up-toggle', function(e) {
    e.preventDefault();
    $(".bb-page").toggleClass("bb-page--help-pop-up-open");
  });

  // Close sizing chart
  $('body').on('click', function (e) {
    // Check if the click is outside the pop up container
    if (!$(e.target).closest('.bb-sizing-chart-container, .bb-sizing-chart-toggle').length) {
      $(".bb-page").removeClass("bb-page--sizing-chart-open");
    }
  });

  // Close help pop up
  $('body').on('click', function (e) {
    // Check if the click is outside the pop up container
    if (!$(e.target).closest('.bb-help-pop-up-container, .bb-help-pop-up-toggle').length) {
      $(".bb-page").removeClass("bb-page--help-pop-up-open");
    }
  });
  
  // Back to top button - site wide
  $('body').on('click', '.js-scroll-to-top', function(e) {
    $('html, body').animate({
        scrollTop: $('body').offset().top
    }, 800);
    e.preventDefault();
  });
  
});
